import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "../lib/api";
import { getCookieConsent } from "../components/CookieBanner";

export default function usePageviewTracker() {
  const location = useLocation();

  useEffect(() => {
    const send = () => {
      if (getCookieConsent() !== "accepted") return;
      api.post("/track/pageview", { path: location.pathname }).catch(() => {});
    };
    send();
    const onConsent = (e) => {
      if (e.detail === "accepted") send();
    };
    window.addEventListener("berulia:cookie-consent", onConsent);
    return () => window.removeEventListener("berulia:cookie-consent", onConsent);
  }, [location.pathname]);
}
